import React, { useState, useEffect } from 'react'
import Spinner from '../../../../../../components/Spinner'
import { connect } from 'react-redux'
import { loadVideoReport, sortVideoReport } from '../../../../../../store/Reports/Video/actions'
import VideoReportItem from '../Video/item'
import List from '../../../../../../components/List'
import SvgArrowUpDown from '../../../../../../components/SVG/ArrowUpDown'
import { nowPlaying } from '../../../../../../store/Reports/actions'


const ReportVideo = ({
    loadVideoReport,
    objects,
    selecteo,
    video_report,
    loading,
    sortVideoReport,
    selected_state,
    date,
}) => {
    let selected
    if (selecteo.length > 0) {
        selected = selecteo
    } else {
        selected = selected_state
    }
    useEffect(() => {
        loadVideoReport({ id: selected[0], date: date })
    }, [])

    const [sort_direction, setSortDirection] = useState("")
    const [trackNotId, setTrackNotId] = useState('')
    const [trackPlaying, setTrackPlaying] = useState(0)
    const [isPlaying, setIsPlaying] = useState(false)
    const [isWatching, setIsWatching] = useState(false)
    const [audio, setAudio] = useState(new Audio())

    const [lastClickedPlayId, setLastClickedPlayId] = useState(-1)
    const [lastClickedPlayNotId, setLastClickedPlayNotId] = useState(-1)

    useEffect(() => {
        if (lastClickedPlayId === trackPlaying && lastClickedPlayNotId === trackNotId) {
            audio.addEventListener("canplaythrough", audio.play)
        }
    }, [audio])

    useEffect(() => {
        hPause()
    }, [selecteo, date])
    const hPlay = ({ trackId, filename, trackNot }) => {
        if (trackId === trackPlaying && trackNotId === trackNot) {
            setLastClickedPlayId(trackId)
            setLastClickedPlayNotId(trackNot)
            audio.play()
            setIsPlaying(true)
            setIsWatching(true)
            setTrackNotId(trackNot)
        } else {
            setLastClickedPlayId(trackId)
            setLastClickedPlayNotId(trackNot)
            audio.pause()
            setTrackPlaying(trackId)
            setTrackNotId(trackNot)
            setIsPlaying(true)
            setIsWatching(true)
            setAudio(new Audio(filename))
        }
    }

    const hPause = () => {
        setIsPlaying(false)
        setIsWatching(false)
        audio.pause()
    }
    const listener = function (e) {
        if (e.target.classList.contains('Object-report_menu-element') || e.target.classList.contains('only_trigger') || e.target.classList.contains('date')) {
            audio.pause()
        }
    }

    document.addEventListener('click', listener, false)

    const hStop = () => {
        setIsPlaying(false)
        setIsWatching(false)
    }
    const sort = (type) => {
        setSortDirection(sort_direction === "up" ? "down" : "up")
        sortVideoReport({ direction: sort_direction, sort_type: type })
        hPause()
        setLastClickedPlayId(-1)
        setLastClickedPlayNotId(-1)
        setTrackNotId('')
        setTrackPlaying(0)
    }

    const hRewind = (totime) => {
        if (audio.currentTime > 0) {
            audio.currentTime = totime
        }
    }

    const getItems = () => {
        return video_report.map((video_report, index) => ({
            id: index,
            name: video_report.name,
            element: <VideoReportItem
                key={index}
                id={index}
                name={video_report.name}
                timestamp={video_report.timestamp}
                playlistname={video_report.playlistname}
                song_author={video_report.song_author}
                clip_id={video_report.clip_id}
                variant={(index % 2 == 0) ? "gray" : ""}
                invalid={video_report.invalid}
                mimetype={video_report.mimetype}
                audio={audio}
                trackPlaying={trackPlaying}
                trackNotId={trackNotId}
                isPlaying={isPlaying}
                isWatching={isWatching}
                play={hPlay}
                pause={hPause}
                stop={hStop}
                rewind={hRewind}
            />
        }))
    }
    return (
        <div>
            {!loading ?
                <div style={{ marginTop: "32px" }}>
                    <div className="VideosReport">
                        <header className="VideosReport__control">
                            <div className="VideosReport__grid">
                                <div className="timestamp" >
                                    <button
                                        className="spp-btn spp-btn_string"
                                        onClick={() => sort("timestamp")}
                                    >
                                        <SvgArrowUpDown className="spp-svg" />
                                        ВРЕМЯ НАЧАЛА
                                    </button>
                                </div>
                                <div className="song">
                                    <button
                                        className="spp-btn spp-btn_string"
                                        onClick={() => sort("name")}
                                    >
                                        <SvgArrowUpDown className="spp-svg" />
                                        РОЛИК
                                    </button>
                                </div>
                            </div>
                        </header>
                    </div>
                    <List
                        type="simple"
                        scroll={{
                            on: true,
                            data: {
                                variant: "white",
                                size: "sm",
                            }
                        }}
                        // variant={ "none" }
                        content={{ items: getItems(), variant: "none" }}
                    />
                </div>
                : <Spinner />
            }

        </div>
    )
}

const stateToProps = state => ({
    objects: state.objects.allObjects,
    selecteo: state.objects.selected,
    selected_state: state.report.selected,
    video_report: state.video_report.video_report,
    loading: state.video_report.loading,
    menu: state.report.menu
})

const actionsToProps = {
    loadVideoReport,
    sortVideoReport,
    nowPlaying
}

export default connect(stateToProps, actionsToProps)(ReportVideo)